var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 204 203",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.212 101.743C203.212 140.669 140.996 202.886 102.069 202.886C63.1422 202.886 0.925163 140.669 0.925163 101.743C0.925163 62.8169 63.1422 0.597961 102.069 0.597961C140.996 0.597961 203.212 62.8169 203.212 101.743ZM142.526 101.743C142.526 117.313 117.638 142.2 102.069 142.2C86.4978 142.2 61.6111 117.313 61.6111 101.743C61.6111 86.1729 86.499 61.2851 102.069 61.2851C117.638 61.2851 142.526 86.1729 142.526 101.743Z",
    fill: "#0065FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickIcon);
export default __webpack_public_path__ + "static/media/click_icon.5077bf7734b4a2e1af207e319eb61127.svg";
export { ForwardRef as ReactComponent };